"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePhone = void 0;
const ValidationResponse_1 = require("./ValidationResponse");
/**
 *
 * Checks if user entered a valid Phone
 * @param {string} pToValidate - The Phone to be validated.
 * @returns {ValidationResponse}
 */
const validatePhone = (pToValidate) => {
    const phonePattern = /^[2-9]\d{9}$/;
    if (pToValidate && !phonePattern.test(pToValidate)) {
        return ValidationResponse_1.ValidationResponse.PHONE_INVALID;
    }
    else {
        return ValidationResponse_1.ValidationResponse.VALID;
    }
};
exports.validatePhone = validatePhone;
